
import { Mapper } from "../../../../base/utils/mapper";
import { StateArcMotionPhysiotherapyModel } from '../../../../domain/models/consult/state-arc-motion-physiotherapy.model';
import { StateArcMotionPhysiotherapyEntity } from '../entities/state-arc-motion-physiotherapy.entity';

export class StateArcMotionPhysiotherapyImplementationRepositoryMapper extends Mapper<StateArcMotionPhysiotherapyEntity, StateArcMotionPhysiotherapyModel>{
    mapFrom(param:  StateArcMotionPhysiotherapyEntity):  StateArcMotionPhysiotherapyModel { 
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }; 
    }
    mapTo(param:  StateArcMotionPhysiotherapyModel):  StateArcMotionPhysiotherapyEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors 
        };
    }
}